import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  GiftDeliveryCategoryData,
  GiftDeliveryCategoryList,
} from './giftDeliveryCategory.interface';

export const giftDeliveryCategoryListStatusAtom = atom<QueryStatus>({
  key: 'giftDeliveryCategoryListStatusAtom',
  default: 'idle',
});

export const giftDeliveryCategoryListDataAtom = atom<GiftDeliveryCategoryList>({
  key: 'giftDeliveryCategoryListDataAtom',
  default: [],
});

export const giftDeliveryCategoryStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftDeliveryCategoryStatusAtomFamily',
  default: 'idle',
});

export const giftDeliveryCategoryDataAtomFamily = atomFamily<
  GiftDeliveryCategoryData | null,
  string
>({
  key: 'giftDeliveryCategoryDataAtomFamily',
  default: null,
});
